"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HIDE = exports.ENTERING = exports.BEFORE_ENTER = exports.EXITING = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _show;

var EXITING = 'EXITING';
exports.EXITING = EXITING;
var BEFORE_ENTER = 'BEFORE_ENTER';
exports.BEFORE_ENTER = BEFORE_ENTER;
var ENTERING = 'ENTERING';
exports.ENTERING = ENTERING;
var HIDE = 'HIDE';
exports.HIDE = HIDE;
var show = (_show = {}, (0, _defineProperty2.default)(_show, HIDE, false), (0, _defineProperty2.default)(_show, BEFORE_ENTER, true), (0, _defineProperty2.default)(_show, ENTERING, true), (0, _defineProperty2.default)(_show, EXITING, true), _show);

var Transition =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(Transition, _React$Component);

  function Transition() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, Transition);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(Transition)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {});
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "timeout", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getDuration", function () {
      return _this.props.transitionTime * 1000 + 50;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "doEnter", function () {
      return _this.updateAnimState(BEFORE_ENTER).then(function () {
        return _this.updateAnimState(BEFORE_ENTER);
      }).then(function () {
        return _this.updateAnimState(ENTERING, _this.getDuration());
      }).then(function () {
        return _this.props.onEntered && _this.props.onEntered();
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "delay", function (callback) {
      var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
      clearTimeout(_this.timeout);
      _this.timeout = setTimeout(callback, delay);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updateAnimState", function (animState, delay) {
      var _resolve;

      var promise = new Promise(function (resolve) {
        return _resolve = resolve;
      });

      _this.setState({
        animState: animState
      }, _this.delay(_resolve, delay));

      return promise;
    });
    return _this;
  }

  (0, _createClass2.default)(Transition, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var hide = this.props.hide;

      if (hide) {
        this.updateAnimState(HIDE);
      } else {
        this.doEnter();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      if (prevProps.hide && !this.props.hide) {
        this.doEnter();
      }

      if (!prevProps.hide && this.props.hide) {
        this.updateAnimState(EXITING, this.getDuration()).then(function () {
          return _this2.updateAnimState(HIDE);
        }).then(function () {
          return _this2.props.onExited && _this2.props.onExited();
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (!this.el) return;
      clearTimeout(this.timeout);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          transitionTime = _this$props.transitionTime;
      var animState = this.state.animState;
      return show[animState] ? children({
        animState: animState,
        transitionTime: transitionTime
      }) : null;
    }
  }]);
  return Transition;
}(_react.default.Component);

exports.default = Transition;
Transition.defaultProps = {
  transitionTime: 0.3
};